'use client';

import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import { debounce } from 'lodash';
import { DEFAULT_SORT_ORDER } from 'commons/constants';

const useSearchUrlQueryParams = () => {
  const history = useHistory();
  const pathname = history?.location?.pathname ?? '';
  const {
    q: queryUrlParam = '',
    category: categoryUrlParam = 'products_jb4',
    sortBy: sortByUrlParam = DEFAULT_SORT_ORDER,
  } = queryString.parse(history?.location?.search ?? '');

  const updateUrlParam = useMemo(
    () =>
      debounce(
        updates => {
          if (updates) {
            const initialUrlParams = queryString.parse(
              history?.location?.search ?? ''
            );

            const updatedUrlParams = queryString.stringify({
              ...initialUrlParams,
              category: initialUrlParams?.category ?? 'products_jb4',
              filter: initialUrlParams?.filter ?? '*',
              ...updates,
            });

            history.replace?.(
              `${history.location.pathname}${
                !history.location.pathname.endsWith('/') ? '/' : ''
              }?${updatedUrlParams}`
            );
          }
        },
        [1000]
      ),
    [history]
  );

  // Immediate version for programmatic updates (like clear, reset)
  const updateUrlParamImmediate = useCallback(
    updates => {
      if (updates) {
        const initialUrlParams = queryString.parse(
          history?.location?.search ?? ''
        );

        const updatedUrlParams = queryString.stringify({
          ...initialUrlParams,
          category: initialUrlParams?.category ?? 'products_jb4',
          filter: initialUrlParams?.filter ?? '*',
          ...updates,
        });

        history.replace?.(
          `${history.location.pathname}${
            !history.location.pathname.endsWith('/') ? '/' : ''
          }?${updatedUrlParams}`
        );
      }
    },
    [history]
  );

  return {
    pathname,
    queryUrlParam,
    categoryUrlParam,
    sortByUrlParam,
    updateUrlParam,
    updateUrlParamImmediate,
  };
};

export default useSearchUrlQueryParams;
